import { compose, hoistStatics } from 'recompose';
import PreviewFile from './PreviewFile';

const enhance = compose();

export default hoistStatics(enhance)(PreviewFile);



// WEBPACK FOOTER //
// ./src/components/previewFile/index.js